<mat-divider></mat-divider>
<footer>
    <span class="version-info">
        Version: 1.0
    </span>
    &copy; All rights reserved 2020
</footer>